import React from 'react';
import { Divider } from 'semantic-ui-react'

const HomeUser1 = ({autorizacUA, styles, handleClickSel1, handleClickSel2, handleClickSel3,
      handleClickSel4, handleClickSel5}) => {
        const a2001 = autorizacUA.findIndex( autorizac => autorizac === "2001" );
        const a2005 = autorizacUA.findIndex( autorizac => autorizac === "2005" );
        const a2010 = autorizacUA.findIndex( autorizac => autorizac === "2010" );
        const a2015 = autorizacUA.findIndex( autorizac => autorizac === "2015" );
        const a2020 = autorizacUA.findIndex( autorizac => autorizac === "2020" );

  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        USUARIOS
      </button>

      {a2001!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
        <i className="large edit violet icon"></i>
        Autorizaciones
      </button>
      }
      {a2005!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
        <i className="large user circle outline violet icon"></i>
        Perfiles
      </button>
      }
      {a2010!==-1 &&
      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
        <i className="large users violet icon"></i>
        Usuarios
      </button>
      }

      {a2015!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel4}>
            <i className="large user secret violet icon"></i>
            Cambiar clave de acceso
          </button>
        </div>
      }

      {a2020!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel5}>
            <i className="large user secret violet icon"></i>
            Cambiar clave a otro usuario
          </button>
        </div>
      }

    </div>
  )
};

export default HomeUser1
